import { axiosInstance } from '../Middleware'
import { Agent } from './types'

export class AgentApi {
  public static loadAgent = (complement?: string) : Promise<Agent []> =>
    axiosInstance.get(`/personnel/personnel/agents${complement ? `?${complement}` : ''}`)
      .then(response => response.data)

  public static updateAgent = (identifiant: number, agentData: Partial<Agent>) : Promise<Agent> =>
    axiosInstance.put(`/personnel/personnel/agents/${identifiant}`, agentData)
      .then(response => response.data)
}
